import { Outlet, useNavigate } from '@tanstack/react-router';
import { useState, useEffect } from 'react';

import { AppSidebar } from './AppSidebar';

import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import { useAuth } from '@/hooks/useAuth';

export function AppLayout() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(() => localStorage.getItem('sidebar:state') !== 'false');

  useEffect(() => {
    if (!isAuthenticated) {
      navigate({ to: '/login' });
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <SidebarProvider
      open={sidebarOpen}
      onOpenChange={open => {
        setSidebarOpen(open);
        localStorage.setItem('sidebar:state', String(open));
      }}
    >
      <AppSidebar />
      <SidebarInset>
        {/*
          Mobile-only, and the only way in. On a phone the sidebar renders as a sheet that opens
          from this trigger and nothing else — without it every page but the dashboard is
          unreachable, which is exactly how it looked from inside the iOS wrapper, where there is
          no address bar to fall back on. Sticky, because you should not have to scroll back to
          the top of a long table to change page.
        */}
        <header className="sticky top-0 z-10 flex h-12 shrink-0 items-center gap-2 border-b bg-background px-4 md:hidden">
          <SidebarTrigger />
          <span className="text-sm font-medium">Postrix</span>
        </header>
        <main className="flex-1 overflow-auto p-6 flex flex-col">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
